import { STRING_REPLACE } from '../enums';

var setHours = function setHours(_ref) {
  var strText = _ref.strText,
      arrHours = _ref.arrHours;
  var OPENHOUR = STRING_REPLACE.OPENHOUR,
      CLOSEHOUR = STRING_REPLACE.CLOSEHOUR;
  var strReplacedText = strText;

  if (strText) {
    var strOpenHour = '';
    var strCloseHour = '';

    if (arrHours) {
      strOpenHour = arrHours[0].replace('h', 'u');
      strCloseHour = arrHours[1].replace('h', 'u');
    }

    strReplacedText = strReplacedText.replace(OPENHOUR, strOpenHour);
    strReplacedText = strReplacedText.replace(CLOSEHOUR, strCloseHour);
  }

  return strReplacedText;
};

export default setHours;